import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./slider.scss";

import styles from "./NewGoods.module.scss";
import { Link } from "react-router";

const NewGoods: React.FC = () => {
  const goodsArr = [
    {
      id: 1,
      img: "/img/main/temp/e2314e74-484c-4763-8ea0-ba94eecf130c.jpeg",
      title: "Вискоза STERHANI Голубые силуэты цветов",
      colors: "1 цвет",
    },
    { id: 2, img: "/img/main/temp/2.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета" },
    { id: 3, img: "/img/main/temp/3.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета" },
    { id: 4, img: "/img/main/temp/4.jpg", title: "Трикотаж WATERPROOF", colors: "2 цвета" },
  ];

  return (
    <section className={styles.newGoods}>
      <div className="container">
        <div className={styles.body}>
          <div className={styles.left}>
            <h2 className={styles.title}>Новинки</h2>
            <p className={styles.description}>Новые поступления качественных тканей и фурнитуры. В наличии - успейте заказать</p>
            <div className={styles.link}>
              <Link to="/catalog">
                <button>Смотреть все новинки</button>
              </Link>
            </div>
          </div>
          <Swiper
            spaceBetween={17}
            loop={true}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
              },
              579: {
                slidesPerView: 3,
              },
              0: {
                slidesPerView: 2,
              },
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {goodsArr.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className={styles.item}>
                  <div className={styles.image}>
                    <img src={slide.img} alt="content" />
                    <div className={styles.materials}>100%полиэстер</div>
                  </div>
                  <h2 className={styles.title}>{slide.title}</h2>
                  <p className={styles.colors}>{slide.colors}</p>
                  <div className={styles.button}>
                    <Link to="/product">
                      <button>Посмотреть</button>
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default NewGoods;
